import { formatResultValue } from "../utils/numericUtils";

export default function FxHedgingResults({ result }) {
    if (!result || Object.keys(result).length === 0) return null;

    return (
        <>
            <div className="fx-results-container">
                <div className="fx-results-left">
                    <table className="fx-results-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>FX EUR/KRW Spot Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{result.start_date}</td>
                                <td>{formatResultValue(result.start_spot, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                            <tr>
                                <td>{result.end_date}</td>
                                <td>{formatResultValue(result.end_spot, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                            <tr className="pl-row">
                                <td>FX EUR/KRW Spot P/L</td>
                                <td>{formatResultValue(result.spot_pl, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="fx-results-right">
                    <table className="fx-results-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>FX EUR/KRW Futures Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{result.start_date}</td>
                                <td>{formatResultValue(result.start_futures, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                            <tr>
                                <td>{result.end_date}</td>
                                <td>{formatResultValue(result.end_futures, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                            <tr className="pl-row">
                                <td>FX EUR/KRW Futures P/L</td>
                                <td>{formatResultValue(result.futures_pl, { isPrice: true, currency: "₩" })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="net-pl-row">
                <span className="net-pl-label">Net EUR/KRW Hedging P/L</span>
                <span className="net-pl-value">{formatResultValue(result.net_pl, { isPrice: true, currency: "₩" })}</span>
            </div>

            <div className="divider double"></div>
        </>
    );
}
